import React from 'react';
import { SubscriptionStatus as SubscriptionStatusEnum } from '../types';
import './SubscriptionStatus.css';

interface SubscriptionStatusProps {
  subscriptionStatus: SubscriptionStatusEnum | string | number;
  trialDaysRemaining?: number;
}

// Função para converter string/número para enum
const parseSubscriptionStatus = (status: SubscriptionStatusEnum | string | number): SubscriptionStatusEnum => {
  if (typeof status === 'number') {
    return status as SubscriptionStatusEnum;
  }
  
  if (typeof status === 'string') {
    const statusMap: Record<string, SubscriptionStatusEnum> = {
      'Trial': SubscriptionStatusEnum.Trial,
      'Paid': SubscriptionStatusEnum.Paid,
      'Cancelled': SubscriptionStatusEnum.Cancelled,
      '0': SubscriptionStatusEnum.Trial,
      '1': SubscriptionStatusEnum.Paid,
      '2': SubscriptionStatusEnum.Cancelled
    };
    return statusMap[status] ?? SubscriptionStatusEnum.Trial;
  }
  
  return status;
};

const SubscriptionStatusComponent: React.FC<SubscriptionStatusProps> = ({
  subscriptionStatus,
  trialDaysRemaining
}) => {
  const parsedStatus = parseSubscriptionStatus(subscriptionStatus);
  
  const getStatusInfo = () => {
    switch (parsedStatus) {
      case SubscriptionStatusEnum.Paid:
        return {
          label: 'Pago',
          className: 'status-paid',
          icon: '✓'
        };
      case SubscriptionStatusEnum.Cancelled:
        return {
          label: 'Cancelado',
          className: 'status-cancelled',
          icon: '🚫'
        };
      case SubscriptionStatusEnum.Trial:
        return {
          label: trialDaysRemaining !== undefined && trialDaysRemaining > 0
            ? `Teste - ${trialDaysRemaining} ${trialDaysRemaining === 1 ? 'dia restante' : 'dias restantes'}`
            : 'Teste',
          className: 'status-trial',
          icon: '⏰'
        };
      default:
        return {
          label: 'Desconhecido',
          className: 'status-unknown',
          icon: '?'
        };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className={`subscription-status ${statusInfo.className}`}>
      <span className="subscription-status-icon">{statusInfo.icon}</span>
      <span className="subscription-status-label">{statusInfo.label}</span>
    </div>
  );
};

export default SubscriptionStatusComponent;

